import { writable } from 'svelte/store';

import { applyDiscount } from '$lib/db/discount';
import { convertPriceToCents, generatePaymentRecord } from '$lib/db/orders';

import isEqual from 'lodash/isEqual';

export const cart = writable<Cart>([]);

export function addDishToCart(cart:Cart, newDish: Dish) {
    let added = false;

    for (const displayDish of cart) {
        if (isEqual(displayDish.dish, newDish)) {
            displayDish.quantity += 1;
            added = true;
        }
    }

    if (!added) {
        cart.push({
            dish: newDish,
            quantity: 1,
        });
    }
}

export function removeDishFromCart(cart:Cart, removeDish: Dish): void {
    for (const displayDish of cart) {
        if (isEqual(displayDish.dish, removeDish)) {
            displayDish.quantity -= 1;

            if (displayDish.quantity === 0) {
                cart.splice(cart.indexOf(displayDish), 1);
            }

            return;
        }
    }
}

export function getCartSize(cart: Cart): number {
    let size = 0;

    for (const displayDish of cart) {
        size += displayDish.quantity;
    }

    return size;
}

export function calculateCartTotal(cart: Cart, discount = false): number {
    let total = 0;

    for (const displayDish of cart) {
        let subtotal = displayDish.dish.price; 

        for (const option in displayDish.dish.options) {
            if (displayDish.dish.selectedOptions[option]) {
                subtotal += displayDish.dish.options[option].price;
            }
        }
        
        subtotal *= displayDish.quantity;
        total += subtotal;
    }

    let dAmount = 0;
    if (discount) {
        for (const displayDish of cart) {
            dAmount += displayDish.dish.discountAmount * displayDish.quantity;

            for (const [index, option] of displayDish.dish.options.entries()) {
                if (displayDish.dish.selectedOptions[index]) {
                    dAmount += displayDish.quantity * (option.discountAmount ?? 0);
                    // console.log(dAmount)
                }                
            }
        }
    }

    // console.log(cart);
    return Math.round((total - dAmount) * 100) / 100;
}

export function calculateFee(cartTotal: number, messageMode: String) {
    let feeCents: bigint = 0n;
    const feePercentage = 0.01;

    if (messageMode === "sms") {
        feeCents += 10n;
    }

    feeCents += convertPriceToCents(cartTotal * feePercentage / 100);

    return feeCents;
}

export function calculatePaymentRecord(cart: Cart, messageMode: string, shopCodes: Discount, appliedCodes: string): PaymentRecord {
    let record: PaymentRecord = generatePaymentRecord();
    
    // get the total price of the line items
    record.totalChargedCents = Number(convertPriceToCents(calculateCartTotal(cart)));

    applyDiscount(shopCodes, appliedCodes, cart);

    record.discountCents = Number(convertPriceToCents(calculateCartTotal(cart, true)));

    // get the app fee for the order
    const fee = calculateFee(record.discountCents, messageMode);
    console.log("Fee: " + fee);
    record.feeCents = Number(fee);

    return record;
}
